/* Shared infinite-loop carousel engine. Extracted verbatim from the home
   carousel (sections/cz-product-carousel.liquid) so the home and the
   product-recommendations carousel share one source of truth. */
if (!window.czCarouselInit) {
  window.czCarouselInit = function (trackEl) {
    if (!trackEl || trackEl.dataset.czCarouselReady) return;
    trackEl.dataset.czCarouselReady = '1';
    var root = trackEl;

    var sliderComponent = root.closest('slider-component');
    var bar = root.parentElement.querySelector('[data-cz-progress]');
    var counterCurrent = root.parentElement.querySelector('.slider-counter--current');
    var counterTotal = root.parentElement.querySelector('.slider-counter--total');
    var desktopMQ = window.matchMedia('(min-width: 990px)');

    var originals = Array.from(root.querySelectorAll('.cz-carousel__slide'));
    var N = originals.length;

    function makeClone(src) {
      var c = src.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.classList.add('cz-carousel__slide--clone');
      c.removeAttribute('id');
      c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      c.querySelectorAll('a').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      return c;
    }

    if (N >= 2) {
      for (var i = 0; i < N; i++) {
        root.insertBefore(makeClone(originals[i]), originals[0]);
      }
      for (var j = 0; j < N; j++) {
        root.appendChild(makeClone(originals[j]));
      }
    }

    var slideStep = 0;
    var batchWidth = 0;
    var snapOffset = 0;
    var ready = false;

    function getColsDesktop() {
      var v = parseInt(getComputedStyle(root).getPropertyValue('--cz-carousel-cols-desktop'), 10);
      return v > 0 ? v : 5;
    }

    function measure() {
      if (N < 2) return;
      var first = originals[0];
      var second = originals[1];
      var firstRect = first.getBoundingClientRect();
      var secondRect = second.getBoundingClientRect();
      slideStep = secondRect.left - firstRect.left;
      if (slideStep <= 0) { ready = false; return; }
      batchWidth = N * slideStep;
      var V = root.clientWidth;
      var W = firstRect.width;
      var styles = getComputedStyle(root);
      var padLeft = parseFloat(styles.paddingLeft || '0') || 0;
      snapOffset = padLeft + W / 2 - V / 2;
      ready = true;
    }

    function scrollLeftForK(K) {
      return K * slideStep + snapOffset;
    }

    function currentK() {
      if (!ready) return N;
      return Math.round((root.scrollLeft - snapOffset) / slideStep);
    }

    function originalIndex(K) {
      return ((K - N) % N + N) % N;
    }

    function setScroll(left) {
      var prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      root.scrollLeft = left;
      root.style.scrollBehavior = prev;
    }

    function setInitial(maintainIdx) {
      var prevIdx = ready ? originalIndex(currentK()) : 0;
      measure();
      if (!ready) return;
      var offsetK;
      if (desktopMQ.matches) {
        offsetK = Math.floor(getColsDesktop() / 2);
      } else {
        offsetK = 0;
      }
      var idx = maintainIdx ? prevIdx : 0;
      var K = N + idx + (maintainIdx ? 0 : offsetK);
      if (K >= 2 * N) K -= N;
      setScroll(scrollLeftForK(K));
      updateProgress();
    }

    function checkWrap() {
      if (!ready) return;
      var K = currentK();
      if (K < N) {
        setScroll(scrollLeftForK(K + N));
        updateProgress();
      } else if (K >= 2 * N) {
        setScroll(scrollLeftForK(K - N));
        updateProgress();
      }
    }

    function updateProgress() {
      if (N < 2) return;
      if (counterTotal) counterTotal.textContent = N;
      if (!ready) return;
      var idx = originalIndex(currentK());
      if (counterCurrent) counterCurrent.textContent = idx + 1;
      if (!bar) return;
      // Fill from (1/N) up to 100% across the set, then loop resets it.
      bar.style.width = ((idx + 1) / N) * 100 + '%';
      bar.style.transform = 'translateX(0)';
    }

    if (N < 2) {
      var fallbackProgress = function () {
        if (!bar) return;
        var max = root.scrollWidth - root.clientWidth;
        var ratio = max <= 0 ? 1 : root.clientWidth / root.scrollWidth;
        var width = Math.max(0.08, Math.min(1, ratio)) * 100;
        var pct = max <= 0 ? 0 : root.scrollLeft / max;
        bar.style.width = width + '%';
        bar.style.transform = 'translateX(' + (pct * (100 - width)) + '%)';
      };
      fallbackProgress();
      root.addEventListener('scroll', fallbackProgress, { passive: true });
      return;
    }

    var prevBtn = root.parentElement.querySelector('button[name="previous"]');
    var nextBtn = root.parentElement.querySelector('button[name="next"]');

    function keepEnabled(btn) {
      if (!btn || typeof MutationObserver === 'undefined') return;
      btn.removeAttribute('disabled');
      var obs = new MutationObserver(function () {
        if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
      });
      obs.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    }
    keepEnabled(prevBtn);
    keepEnabled(nextBtn);

    function applySliderLoopingFlag() {
      if (sliderComponent) sliderComponent.enableSliderLooping = true;
    }
    applySliderLoopingFlag();
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('slider-component').then(applySliderLoopingFlag);
    }

    if (sliderComponent) {
      requestAnimationFrame(function () {
        if (typeof sliderComponent.resetPages === 'function') sliderComponent.resetPages();
      });
    }

    requestAnimationFrame(function () { setInitial(false); });
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () {
        setInitial(false);
        setTimeout(function () { setInitial(false); }, 80);
      });
    } else {
      setTimeout(function () { setInitial(false); }, 80);
    }

    var wrapTimer;
    root.addEventListener('scroll', function () {
      updateProgress();
      clearTimeout(wrapTimer);
      wrapTimer = setTimeout(checkWrap, 120);
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { setInitial(true); }, 80);
    });

    desktopMQ.addEventListener('change', function () {
      setTimeout(function () { setInitial(true); }, 50);
    });

  };
}
